<template>
  <div class="app-container">
    <el-tabs v-model="activeName" @tab-click="handleClicktab">
      <el-tab-pane label="卷板费用明细" name="first" v-if="btnFlg[3]">
        <cost-breakdown-j-b ref="jbCost"></cost-breakdown-j-b>
      </el-tab-pane>
      <el-tab-pane label="建材费用明细" name="second" v-if="btnFlg[4]">
        <cost-breakdown-j-c ref="jcCost"></cost-breakdown-j-c>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import costBreakdownJB from './costBreakdownJB.vue'
import costBreakdownJC from './costBreakdownJC.vue'
import { getBtn } from '@/utils/getButton'

export default {
  components: { costBreakdownJB, costBreakdownJC },
  data () {
    return {
      activeName: 'first',
      btnFlg: [],
      btnIdArr: ['003P01dB001', '003P01dB002', '003P01dB003', '003M310100', '003M310200', '003M310300', '003M310400', '003M310500', '003M310600']
    }
  },
  methods: {
    handleClicktab (tab, event) {
      console.log(tab, event)
      this.$refs.jbCost.chongzhi()
      this.$refs.jcCost.chongzhi()
    }

  },
  created () {

  },
  mounted () {
    this.btnFlg = getBtn(this.btnIdArr, '/costBreakdown')
    this.activeName = this.btnFlg[3] ? 'first' : 'second'
  }
}
</script>

<style lang="less" scoped>
.inpBox {
  .el-form-item {
    margin-left: 10px;
    margin-bottom: 0px;
  }
}
/deep/.el-table th.star div::before {
  content: '*' !important;
  color: red !important;
}
    /deep/.el-tabs__header{
  margin-bottom: 0;
}
</style>
